import { AnalysisFileType } from "../../../types/analysisFileTypes";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../../scaffold/ui/LinkTypes";
import GenericAnalysisFilesAdminPage from "./GenericAnalysisFileAdminPage";


export default function UpcomingBonusRewardsAnalysisFilesAdminPage() {
    return <GenericAnalysisFilesAdminPage
        fileType={AnalysisFileType.UpcomingBonusRewardsAnalysisFile}
        title={SidebarLinkTypes.superAdminAnalysisFilesUpcomingBonusRewards}
        link={SidebarLinkPathTypes.superAdminAnalysisFilesUpcomingBonusRewards}
    />
}